import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ConfigClass } from 'components';
import { Label, Icon } from 'semantic-ui-react';

import classNames from 'classnames/bind';
import styles from './ConfigTemplate.css';
const cx = classNames.bind(styles);

const ConfigTemplate = ({ isAuth, order, lists, ...rest }) => {
  const childDom = [];
  for (let i = 0; i < order.length; i++) {
    childDom.push(
      <ConfigClass
        isAuth={isAuth}
        key={'confSmtp' + i + order[i]}
        classTitle={order[i]}
        classChild={lists[order[i]]}
        {...rest}
      />
    );
  }

  return <div className={cx('config-template')}>{childDom}</div>;
};

ConfigTemplate.propTypes = {
  category: PropTypes.string.isRequired,
  order: PropTypes.array.isRequired,
  lists: PropTypes.object.isRequired
};
ConfigTemplate.defaultProps = {
  category: 'basic',
  order: [],
  lists: {}
};

export default ConfigTemplate;



// WEBPACK FOOTER //
// ./src/script/components/config/ConfigTemplate.js